import React, { useState } from "react";
import MobileNumber from "./MobileNumber";
import OTP from "./OTP";
import ConfirmPassword from "./ConfirmPassword";

const Forgot = ({ onClose }) => {
  const [page, setPage] = useState(0);
  const [otp, setOtp] = useState("");

  return (
    <>
      {page === 0 && <MobileNumber setPage={setPage} onClose={onClose} />}
      {page === 1 && (
        <OTP setPage={setPage} onClose={onClose} setOtp={setOtp} otp={otp} />
      )}
      {page === 2 && (
        <ConfirmPassword setPage={setPage} onClose={onClose} otp={otp} />
      )}
    </>
  );
};

export default Forgot;
